<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .cta-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: utils.in_rem(4px);

    .cta-label {
      overflow: hidden;
      text-overflow: ellipsis;
      color: colors.get(black_90);
      @include mixins.body4();
    }
  }
</style>

<script>
  // Svelte
  import { getContext } from "svelte";
  // Functions
  import { wrappedSpreadsheetMap } from "../../../modals/AddToCampaign/utils";
  // Components
  import ButtonWithTooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/ButtonWithTooltip.svelte";
  // Context
  import { CONTACT_CTAS_CONTEXT } from "./context";

  export let actionedFrom;

  // Get store from context
  const { candidateStore } = getContext(CONTACT_CTAS_CONTEXT);

  // Search Page TODO: check what happens when wrappedSpreadsheetMap errors
  const onclick = async () => {
    const candidates = [$candidateStore];
    const params = await wrappedSpreadsheetMap({ candidates });

    // For Search Page tracking
    if (actionedFrom) params.actionedFrom = actionedFrom;

    window.location = `/review?${new URLSearchParams(params).toString()}`;
  };
</script>

<div class="cta-wrapper">
  <ButtonWithTooltip
    kind="secondary"
    class=""
    leadingIcon="fa-regular fa-user-plus"
    trailingIcon=""
    size="candidate-cta"
    placement="top"
    {onclick}
  >
    <span slot="tooltip">Add to contacts</span>
    <!-- Icon needs to be leadingIcon, so the loading state renders correctly -->
  </ButtonWithTooltip>
  <span class="cta-label">Contacts</span>
</div>
